import React, { Component, Fragment } from "react";
import DispatchProps from "../../../utils/DispatchProps";
import TenantPackageSummary from "../../../models/TenantPackageSummary";
import { IRootState } from "../../../store";
import TenantPackageSummaryList from "../../TenantPackageSummaryList";
import { connect } from "react-redux";
import SchoolList from "../../SchoolList";
import SharePointAppList from "../../SharePointAppList";
import School from "../../../models/School";
import SharePointApp from "../../../models/SharePointApp";
import ApiService from "../../ApiService";
import Actions from "../../../redux/Actions";
import { MessageBarType } from "office-ui-fabric-react/lib-commonjs";
import PageTitle from "../../PageTitle";
import SharePointPackage from "../../../models/SharePointPackage";


interface TenantPackageManagementPageProps {
    tenantId: string;
    apiService: ApiService;
}

interface TenantPackageManagementPageState {
    tenant?: TenantPackageSummary;
    tenantSchools?: School[];
    tenantSharePointApps?: SharePointApp[];
    availableSharePointPackages?: SharePointPackage[];
}

class TenantPackageManagementPage extends Component<TenantPackageManagementPageProps & DispatchProps, TenantPackageManagementPageState> {
    static displayName = TenantPackageManagementPage.name;

    constructor(props: TenantPackageManagementPageProps & DispatchProps) {
        super(props);

        this.state = {};
    }

    async componentDidUpdate(prevProps: Readonly<TenantPackageManagementPageProps & DispatchProps>, prevState: Readonly<TenantPackageManagementPageState>, snapshot?: any): Promise<void> {
        if (this.props.tenantId !== prevProps.tenantId) {
            await this.loadTenantData(this.props.tenantId);
        }
    }

    async componentDidMount() {
        if (this.props.tenantId) {
            await this.loadTenantData(this.props.tenantId);
        }

        var availableSharePointPackages = await this.props.apiService.getAvailableSharePointPackages();
        this.setState({ availableSharePointPackages: availableSharePointPackages });
    }

    private async loadTenantData(tenantId: string) {
        const tenant = await this.props.apiService.getTenantPackageSummaryAdmin(tenantId);
        const tenantSchools = await this.props.apiService.getTenantSchoolsAdmin(tenantId);
        const tenantSharePointApps = await this.props.apiService.getTenantSharePointAppsAdmin(tenantId);

        this.setState({
            tenant: tenant,
            tenantSchools: tenantSchools,
            tenantSharePointApps: tenantSharePointApps,
        });
    }

    private saveSharePointAppChanges() {
        var that = this;
        return async (sharePointAppChanges: SharePointApp[]): Promise<boolean> => {
            try {
                // Save Changes
                await that.props.apiService.addOrUpdateSharePointAppsAdmin(that.props.tenantId, sharePointAppChanges);
                await that.props.apiService.startWorkloadForTenants([that.props.tenantId], 'SetupSharePointApps')

                // Re-load
                const tenantSharePointApps = await that.props.apiService.getTenantSharePointAppsAdmin(that.props.tenantId);
                that.setState({
                    tenantSharePointApps: tenantSharePointApps,
                });

                that.props.dispatch(Actions.showMessageBar("SharePoint app changes saved", MessageBarType.success));
                return true;
            }
            catch (e) {
                console.log(e);
                that.props.dispatch(Actions.showMessageBar("SharePoint app changes failed", MessageBarType.error));
                return false;
            }
        }
    }

    render() {
        return (
            <Fragment>
                <PageTitle title={this.state.tenant?.tenantName}/>
                <TenantPackageSummaryList
                    title={this.state.tenant?.tenantName}
                    tenantPackageSummaries={this.state.tenant ? [this.state.tenant] : []}
                    enableRowLinks={false}>
                </TenantPackageSummaryList>
                <SchoolList
                    title={`${this.state.tenant?.tenantName} schools`}
                    schools={this.state.tenantSchools ? this.state.tenantSchools : []}
                    enableRowLinks={true}>
                </SchoolList>
                <SharePointAppList
                    title={`${this.state.tenant?.tenantName} SharePoint apps`}
                    sharePointApps={this.state.tenantSharePointApps ? this.state.tenantSharePointApps : []}
                    editable={true}
                    availableSharePointPackages={this.state.availableSharePointPackages}
                    onSave={this.saveSharePointAppChanges()}>
                </SharePointAppList>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): TenantPackageManagementPageProps => {
        const tenantId = ownProps.match.params.tenantId;
        return {
            tenantId: tenantId,
            apiService: state.auth.apiService
        };
    }
)(TenantPackageManagementPage);